module.exports = __webpack_public_path__ + "static/media/Protractor.1ab7337b.gif";